export default {
  onboarding: {
    welcome: {
      title: "Welcome to",
      subtitle: "Your go-to sports betting research app for props, parlays, and top trends. Time to level-up.",
      headline: "Find your next bet",
      secondaryCta: "Already have an account? Sign in",
    },
    leagues: {
      title: "Choose your favorite leagues",
      subtitle: "See the leagues you care about first, every time you open the app.",
    },
    location: {
      title: "See what's available near you",
      subtitle: "Enable location to see which operators and offers are available in your area.",
      allowLocationSharing: "Allow location sharing",
      orSelectRegion: "or select your region",
    },
    providers: {
      title: "Pick your operators",
      subtitle: "Choose your operators for personalized trends, odds, and a smoother betslip experience.",
      emptyCta: "I don't have one yet",
    },
    odds: {
      title: "Choose your odds format",
      subtitle: "View odds in the format you're most comfortable with for quicker, easier decisions.",
    },
    socialProof: {
      title: "Trusted by bettors everywhere",
      subtitle: "From first-time users to daily bettors, Linemate delivers smarter insights at scale",
      reviewer: "App store reviewer",
      reviews: {
        review1: {
          title: "Genuinely best designed app I’ve encountered in a while.",
          text: "Everything is just where it needs to be, the functions of each selection work as intended, very intricately designed app that is mostly very information-heavy, yet so efficient and organized in its approach. As a stats nerd, I give my well done to Linemate for their app design, and the ease of finding lock'n'loads."
        },
        review2: {
          title: "Best App of All",
          text: "This is 100% the best app for sports betting… after trying it out for a few days i was sold. i highly recommend the paid version as this app so you can get the full version of what it has to offer… you won't be disappointed! download with confidence and enjoy!"
        },
        review3: {
          title: "The best",
          text: "I've tried a lot of stat apps. Linemate is the one I keep coming back to. They offer the most for free, keep adding features without taking anything away, and the Plus plan is well worth the price. Support replied in 5 minutes. They clearly care about being the go-to app. Highly recommended."
        },
        review4: {
          title: "Pleasantly surprised",
          text: "If you're new and blindly follow props, results will vary, you still need strategy. I downloaded Linemate after my parlays kept missing by small margins, and my first 7-leg player prop parlay hit. For $10/month (with a free first week), it's easily worth it. It won't be perfect, but it does most of the heavy lifting."
        },
        review5: {
          title: "Great App!",
          text: "No betting app is ever 100%, but this one has delivered the best results for me so far. It's all real stats and data. The free version is solid, and the subscription is even better, you can easily make it back with this app."
        },
        review6: {
          title: "Great App that Stands Out",
          text: "Great app that really stands out, affordable with strong features for research. Overall, amazing work, keep it up."
        },
      },
    },
    summary: {
      title: "Your profile is ready",
      subtitle: "We've personalized the app based on your choices. Create your profile to save it and get started.",
      leagues: "Your leagues",
      location: "Your location",
      oddsFormat: "Your odds format",
      operators: "Your operators",
      noOperators: "No operators",
    },
    consent: {
      title: "Stay in the loop",
      subtitle: "Get updates on features, improvements, and offers. Unsubscribe anytime.",
      emailToggle: "Get updates & exclusive offers by email",
      pushToggle: "Enable notifications for real-time insights",
      confirm: "Confirm my choices",
    },
  },
};